'use strict';

PagingPreprocessorFactory.$inject = ['mx.shell.Config', 'mx.SolutionBuilderAgent.PersonalizationService', 'mx.SolutionBuilderAgent.BasePreprocessor'];
export default function PagingPreprocessorFactory(config, personalizationService, BasePreprocessor) {
	function PagingPreprocessor() {
		BasePreprocessor.apply(this);
		let pageSize = 0;
		this._personalizedPageSize = 0;
		this.type = mx.SolutionBuilderAgent.PreprocessorType.Paging;

		Object.defineProperty(this, 'pageSize', {
			get: function () {
				return pageSize;
			},
			set: function (size) {
				size = parseInt(size);
				if (!isNaN(size) && this.pageSize !== size) {
					this.page = 1;
					pageSize = size;
					this.callChanged();
				}
			},
		});

		return this;
	}

	PagingPreprocessor.prototype = angular.extend(Object.create(BasePreprocessor.prototype), {
		load: async function () {
			const dataSource = config.get('dataSource');
			this._personalizedPageSize = await personalizationService.getPageSize();
			let localPageSize = this._personalizedPageSize || dataSource.pageSize;
			this.pageSizes = dataSource.pageSizes;

			if (this.pageSizes.indexOf(localPageSize) < 0) {
				localPageSize = this.pageSizes[0];
			}

			this._pageSize = this.pageSize = localPageSize;
			this._page = 0;
			this.page = 0;
			this.count = 0;
			return true;
		},

		build: function () {
			// Todo: as backend use page-1
			return this.executor.paginationBuild(this.pageSize, this.page > 0 ? this.page - 1 : 0);
		},

		callChanged: function () {
			if (this._page === this.page && this._pageSize === this.pageSize) {
				return;
			}

			if (this._personalizedPageSize !== this.pageSize) {
				personalizationService.savePageSize(this.pageSize);
			}

			this._pageSize = this.pageSize;
			this._page = this.page;
			this.changed();
		},

		process: function (data, totalCount) {
			this.count = Number(totalCount);
		},

		clear: function () {
			this._page = 0;
			this.page = 0;
		},
	});

	return PagingPreprocessor;
}
